/**
 * Application geometry options.
 * Automatically loaded on application initialization and available as app.metrics.
 */

'use strict';

// public
module.exports = {
    480: {
        // screen base dimension
        height: 480,
        width: 720,
        // safe zone margins
        availTop: 24,
        availBottom: 24,
        availRight: 62,
        availLeft: 62,
        // project-specific vars
        appMenuRows: 1,
        appMenuCols: 4
    },

    576: {
        // screen base dimension
        height: 576,
        width: 720,
        // safe zone margins
        availTop: 24,
        availBottom: 24,
        availRight: 62,
        availLeft: 62,
        // project-specific vars
        appMenuRows: 2,
        appMenuCols: 4
    },

    720: {
        // screen base dimension
        height: 720,
        width: 1280,
        // safe zone margins
        availTop: 28,
        availBottom: 28,
        availRight: 66,
        availLeft: 66,
        // project-specific vars
        appMenuRows: 2,
        appMenuCols: 6
    },

    1080: {
        // screen base dimension
        height: 1080,
        width: 1920,
        // safe zone margins
        availTop: 42,
        availBottom: 42,
        availRight: 75,
        availLeft: 75,
        // project-specific vars
        appMenuRows: 2,
        appMenuCols: 6
    }
};
